import React from 'react';
import { Link } from 'react-router-dom';
import { useSchool } from '../contexts/SchoolContext';
import './ContentPage.css';

// Facilities confirmed by the school (School Settings). Only listed facilities are shown.
const Facilities = () => {
  const { settings } = useSchool();
  const facilities = settings.facilities ?? [];

  return (
    <div className="content-page">
      <section className="section">
        <div className="container content-container">
          <h1>Our Facilities</h1>
          {facilities.length === 0 ? (
            <div className="content-empty">
              <p>Details of our facilities are being prepared.</p>
              <p>The best way to see the school is to visit us.</p>
            </div>
          ) : (
            <ul className="facility-grid">
              {facilities.map((f, i) => (
                <li key={i} className="facility-card">
                  <h2>{f.name}</h2>
                  <p>{f.description}</p>
                </li>
              ))}
            </ul>
          )}
          <p className="content-more">
            <Link to="/contact?type=visit_request" className="btn btn-primary">Request a visit</Link>
          </p>
        </div>
      </section>
    </div>
  );
};

export default Facilities;
